import React, { useState, useEffect } from "react";
import { Col, Row, Pagination, Modal } from "react-bootstrap";
import Chart from "react-apexcharts";
import { useDispatch, useSelector } from "react-redux";
import { getTransactionFromUserId } from "store/actions";
import { Oval } from 'react-loader-spinner'
import { useOutletContext } from "react-router-dom";
import { Input, PaginationItem, PaginationLink } from "reactstrap";
import PreviewNFT from "Pages/SaleNft/PreviewNFT";
export default function HomeDashboard() {
  const [menu, menuopen] = useOutletContext();
  useEffect(() => {
    menu(false)
  }, [menu])
  const user_id = useSelector((s) => s?.Login?.user?._id)
  const { transactionsFromUserID, loading } = useSelector((s) => s?.Transactions)
  const [buySellData, setBuySellData] = useState([])
  const dispatch = useDispatch()
  useEffect(() => {
    if (user_id) {
      let body = {}
      body.user_id = user_id
      body.buySell = false

      dispatch(getTransactionFromUserId(body))
    }
  }, [user_id])


  useEffect(() => {
    setBuySellData(transactionsFromUserID)

  }, [transactionsFromUserID])

  useEffect(() => { console.log("buySellData", buySellData) }, [buySellData])

  const state = {
    options: {
      chart: {
        height: 350,
        id: "basic-bar"
      },
      xaxis: {
        categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999],

      },
      stroke: {
        show: true,
        curve: 'smooth',
        lineCap: 'butt',
        colors: undefined,
        width: 3,
        dashArray: 0,
      },
      dataLabels: {
        enabled: false
      },
      grid: {
        show: true,
        borderColor: '#90A4AE',
        strokeDashArray: 0,
        position: 'back',
        xaxis: {
          lines: {
            show: false
          }
        },
        yaxis: {
          lines: {
            show: false
          }
        },
        row: {
          colors: undefined,
          opacity: 0.5
        },
        column: {
          colors: undefined,
          opacity: 0.5
        },
        padding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        },

      },


    },
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'light',
        type: "horizontal",
        shadeIntensity: 0.5,
        gradientToColors: ['#90A4AE', 'transparent'], // optional, if not defined - uses the shades of same color in series
        inverseColors: true,
        opacityFrom: 0.7,
        opacityTo: .2,
        stops: [0, 50, 100],
        colorStops: [0, 50, 100]
      }
    },

    series: [
      {
        name: "High - 2013",
        data: [28, 80, 90, 60, 75, 50, 65, 87, 54]
      },
      // {
      //   name: "Low - 2013",
      //   data: [12, 11, 14, 18, 17, 13, 13]
      // }
    ],

  };

  // pagination
  const [dataLength, setDataLength] = useState([]);
  const [dataAfterPagination, setDataAfterPagination] = useState([]);
  var [values, setValues] = useState(10);
  var [sNoValue, setSNovalue] = useState(0);
  useEffect(() => {
    let x = 0;
    if (buySellData?.length < 9) {
      x = 1;
    } else {
      x = Math.ceil(buySellData.length / 10);
    }
    const newLengthArray = Array.from({ length: x }, (_, index) => index + 1);
    setDataLength(newLengthArray);
  }, [buySellData]);
  useEffect(() => {
    if (buySellData?.length < 9) {
      setDataLength([1]);
    } else {
      const x = Math.ceil(buySellData.length / 10);
      const newLengthArray = Array.from({ length: x }, (_, index) => index + 1);
      setDataLength(newLengthArray);
    }
  }, [buySellData]);
  useEffect(() => {
    let arr = [];
    setSNovalue(values - 10);
    for (let i = values - 10; i < values; i++) {
      if (buySellData[i]) {
        arr.push(buySellData[i]);
      }
    }
    setDataAfterPagination(arr);
  }, [values, buySellData, dataLength]);
  const handlePagination = (val) => {
    let valu = 0;
    if (val === "<<") {
      valu = 10;
    } else if (val === "<") {
      valu = Math.max(0, values - 10);
    } else if (val === ">" && sNoValue / 10 < values) {
      valu = (parseInt(values / 10) + 1) * 10;
    } else if (val === ">>" && values < buySellData.length) {
      valu = Math.ceil(buySellData.length / 10) * 10;
    } else {
      valu = parseInt(val) * 10;
    }
    setValues(valu);
  };
  const [viewnftDialog, setviewnftDialog] = useState(false)
  const [nftlink, setNftLink] = useState()
  const viewnftBtn = (data) => {
    setviewnftDialog(!viewnftDialog)
    setNftLink(data)
  }
  const [timezone, setTimezone] = useState()
  useEffect(() => {
    const timezoneString = Intl.DateTimeFormat().resolvedOptions().timeZone;
    setTimezone(timezoneString)
  }, [])
  return (
    <>
      {(loading) &&
        <div className='loaderBoxMiane'>
          <Oval
            height={80}
            width={80}
            color="#6C63FF"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel='oval-loading'
            secondaryColor="#6C63FF"
            strokeWidth={2}
            strokeWidthSecondary={2}

          />
        </div>
      }
      <Modal className="EmailVerifyBoxModel previewnftDialog text-center" show={viewnftDialog} centered animation={false}>
        <PreviewNFT fucn={viewnftBtn} nftData={nftlink} />
      </Modal>
      <Row>
        <Col lg={12} className="mb-4">
          <div className="d-flex w-100 align-items-center justify-content-between flex-wrap">
            <h1 className="mb-0"><i onClick={menuopen} className="fa-light fa-bars-sort"></i> Dashboard </h1>
          </div>
        </Col>
        {/* <Col lg={12} className="mb-4">
          <div className="dahboardBox">
            <Row>
              <Col className="my-auto" lg={4}>
                <div className="monthlySalebs">
                  <h1>$250 <sub className="up"><i className="fa-regular fa-arrow-trend-up"></i> 20%</sub></h1>
                  <h2>Monthly Sale</h2>
                </div>
              </Col>
              <Col lg={8}>
                <div className="mixed-chart">
                  <Chart
                    options={state.options}
                    series={state.series} height="250"
                    type="area" className="chartbox"
                  />
                </div>
              </Col>
            </Row>
          </div>
        </Col> */}
        <Col lg={12} className="mb-4">
          <div className="dahboardBox">
            <h5 className="fw-semibold border-bottom pb-3">Activity</h5>
            <div className="table-responsive tableNft">
              <table>
                <thead>
                  <tr>
                    <td className="text-center">No.</td>
                    <td>Event</td>
                    <td>Artwork Name</td>
                    <td>Price</td>
                    <td>Type</td>
                    <td className="text-center pe-4">Quantity</td>
                    <td>From</td>
                    <td>To</td>
                    <td>Date</td>
                    {/* <td className="text-center">View</td> */}
                  </tr>
                </thead>
                <tbody>
                  {dataAfterPagination.length > 0 ? (
                    <>
                      {dataAfterPagination && dataAfterPagination.map((item, index) =>
                        <tr>
                          <td className="text-center">{sNoValue += 1}</td>

                          <td>{item?.sale_type === "minted" ? "Minted" : item?.sale_type === "bid" ? "Bid" : (item?.seller_id === user_id ? "Sold" : "Bought")}</td>
                          <td><img onClick={() => viewnftBtn(item)} className="nftimge cursor-pointer " alt="" src={item?.nft_id?.image_id?.image?.link} /> {item?.nft_id?.name}</td>
                          <td>{item?.price|| item?.total_price_matic} POL</td>
                          <td className="text-center pe-4">{item?.no_of_copies ? item?.no_of_copies : 1}</td>
                          <td className="text-center pe-4">{item?.type}</td>
                          <td>{item?.from?.substring(0, 5)}.....{item?.from?.substring(item?.from?.length - 4, item?.from?.length)}</td>
                          <td>{item?.to?.substring(0, 5)}.....{item?.to?.substring(item?.to?.length - 4, item?.to?.length)}</td>
                          <td> {new Date((item?._sortDate) * 1000).toLocaleString('en-IN', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true, timeZone: timezone })}
                          </td>
                          {/* <td className="text-center">
                        <button className="btn border-0 "><i className="fa-regular fa-eye"></i></button>
                        </td> */}
                        </tr>)}
                    </>
                  ) : (
                    <>
                      <tr>
                        <td className="text-center py-4" colSpan={8}>No Data Available</td>
                      </tr>
                    </>)}

                </tbody>
              </table>
            </div>
          </div>

          <Col lg={12} className="text-end">
            <Pagination className="paginationNew" aria-label="Page  navigation example">
              {values > 10 &&
                <div className="d-flex align-items-center gap-2">
                  <PaginationItem >
                    <PaginationLink
                      first
                      href="#"
                      onClick={() => handlePagination("<<")}
                    />
                  </PaginationItem>
                  <PaginationItem >
                    <PaginationLink
                      href="#"
                      previous
                      onClick={() => handlePagination("<")}
                    />
                  </PaginationItem>
                </div>
              }
              {dataLength && dataAfterPagination.length > 0 && dataLength.map((item) =>
                <PaginationItem className={parseInt(item) === (values / 10) ? "active" : ""}>
                  <PaginationLink href="#" onClick={() => handlePagination(item)}>
                    {item}
                  </PaginationLink>
                </PaginationItem>
              )}
              {values < buySellData.length &&
                <div className="d-flex">
                  <PaginationItem>
                    <PaginationLink
                      href="#"
                      next
                      onClick={() => handlePagination(">")}
                    />
                  </PaginationItem>
                  <PaginationItem>
                    <PaginationLink
                      href="#"
                      last
                      onClick={() => handlePagination(">>")}
                    />
                  </PaginationItem>
                </div>
              }
            </Pagination>
          </Col>
        </Col>
      </Row>
    </>
  );
}
